'use client'
export { ScrollView, type ScrollViewProps } from 'react-native'
